export enum ErrorCode {
  ContactExistsInThisGroup = 1,
  DuplicateTitleOrName = 2,
  FileIsInvalid = 3,
  NotAllowedContactsCount = 4,
  CacheKeyNotFound = 5,
  ContactAlreadyExists = 6,
  MobileUsedByAnotherUser = 7,
  UserNotFound = 8,
  UserIsSuspended = 9,
  MobileVerificationCodeIsWrong = 10,
  UserApiKeyLimitationCount = 11,
  AlreadyReturnInvoiceIssued = 12,
  // UserCouldNotHasOfficialInvoice = 13,
  PasswordIsWrong = 14,
  UserDeactivationAllowed24Hours = 15,
  DuplicateEmailAddress = 16,
  DuplicateUserName = 17,
  DuplicateInvoiceNumber = 18,
  DiscountCodeIsWrong = 19,
  DiscountCodeHasExpired = 20,
  DiscountCodeUsageLimitationReached = 21,
  UserLinePrebuyExists = 22,
  DuplicatePlanLineNumber = 23,
  DuplicateUserLineNumber = 24,
  CantModifyStartedABTest = 25,
  ItemCountLimitation = 26,
  EventIsRelatedToTheCampaign = 27,
  ContactGroupUsedInCampaign = 28,
  EmailVerificationAllowedPer2Minutes = 29,
  LineUsedOnAnotherModule = 30,
  SmsSecretaryBehaviorLimitationCount = 31,
  DuplicateParameter = 32,
  CreditNotEnough = 33,
  KeyWordIsDuplicated = 34,
  TestFastSendLimitationCount = 35,
  RetryOperation = 36,
  OverlapInRanges = 37,
  UsableSystemLine = 38,
  SystemLineExist = 39,
  DuplicateBlockedIP = 40,
  TempRefCodeIsExpired = 41,
  ParameterUsedInBlackListKeywords = 42,
  CooperationMessageParameterLimitationCount = 43,
  ParameterUsedOnAnotherModule = 44,
  UserHasOpenRequest = 45,
  RegistrationThroughTempCodeHasAlreadyBeenDone = 46,
  SepidarRegisterCustomerFailed = 47,
  SepidarRegisterInvoiceFailed = 48,
  SepidarRegisterReceiptFailed = 49,
  AddValidIPForTwoStepLoginLimitationCount = 50,
  AddValidMobileToSendVerificationCodeLimitationCount = 51,
  UsersMobileCannotBeInTheWhiteList = 52,
  UserHaveAnyManualPaymentWaitingToConfirmAdmin = 53,
  DefaultMessageInCodeReaderIsRequired = 54,
  UserMustModifyUnderSupervisionFinancialDepartment = 55,
  DowngradePlanIsNotPermitted = 56,
  AlreadyHasNotExpiredPlan = 57,
  UserAccessDenied = 58,
  UserAccessLimitationCountUserTemplate = 59,
  UserAccessLimitationCountBlackListInquiryCount = 60,
  UserAccessLimitationCountFastSend = 61,
  UserAccessLimitationApiKey = 62,
  UserAccessLimitationSmsTransmissionApiWithParameter = 63,
  UserAccessLimitationSmsTransmissionEmailWithParameter = 64,
  UserAccessLimitationSmsTransmissionMobileWithParameter = 65,
  UserAccessLimitationSmsSecretaryWithParameter = 66,
  UserAccessLimitationCodeReaderParameters = 67,
  UserAccessLimitationContacts = 68,
  UserAccessLimitationContactGroups = 69,
  UserAccessLimitationContactEvents = 70,
  //PreviousDaysHasPendingInvoice = 72,
  MobileIsBlocked = 73,
  MobileIsAlreadyBlocked = 74,
  PaymentLimitations = 75,
  ABTestSelectedContactLessThanMin = 76,
  CantModifyMessageTextOfHandledScheduledCampaign = 77,
  SendSmsViaTowerRequestIsExpired = 78,
  SendSmsViaTowerRequestIsUnchangeable = 79,
  UserInvoiceIsAlreadyCancelled = 80,
  NotSupportedSepidarLocation = 81,
  NotSupportedSepidarBankType = 82,
  PublicLineIsNotActive = 83,
  UserDoesNotHaveAccessToSpecialLines = 84,
  PublicLineSendLimitationCount = 85,
  DuplicateAdvertisingCampaignName = 86,
  DuplicateAdvertisingCampaignCode = 87,
  SendSmsTypeDeactivated = 88,
  InternalOperationsLineMustBeUnique = 89,
  SystemLineTypesMustBeTaken = 90,
  SystemLineHasTypeMustBeActive = 91,
  UserTagNotFound = 92,
  UserTagsAreNotOfTheSameType = 93,
  UserTagNameDuplicated = 94,
  LegalDataIncompleteForRegisterInSepidar = 95,
  CustomerNationalIdForRegisterInSepidarEmpty = 96,
  HasConflictCustomerNameInSepidar = 97,
  CustomerHasSameNameExistInSepidar = 98,
  PaymentGatewayUnreachable = 99,
  DiscountCodeCouldNotAffectTheCreditTier = 100,
  UserHasUnfinishedRequest = 101,
  FAQServiceUnreachable = 102,
  FAQQuestionDuplicated = 103,
  FAQCategoryTitleDuplicated = 104,
  CouldNotConnectToSepidar = 107,
  PlanIsNotAvailable = 108,
  // PlanAccessibility = 109,
  DailyCreditTransactionLimitExceeded = 110,
  ManagerPendingSendMessageCodeIsNotValid = 111,
  ManagerPendingSendMessageCodeIsAlreadySent = 112,
  CouldNotConnectToReportService = 113,
  ReportRequestTimeout = 114,
  NumberOfRecordsHasExceededTheLimit = 115,
  ReportServiceTerminated = 116,
  PayamakSefidServiceConnectionFailed = 117,
  UserHasSamePayamakSefidDeviceName = 118,
  PayamakSefidDeviceIsAlreadyConnected = 119,
  PayamakSefidContactGroupIsInUseByDevices = 120,
  DeviceContactGroupExists = 121,
  CannotRemoveDefaultContactGroup = 122,
  XMAServiceConnectionFailed = 123,
  XMAPlanAccessLimitation = 124,
  PayamakSefidContactGroupHasContacts = 125,
  PayamakSefidPlanContactsCountLimitation = 126,
  MessageCountExceeded = 127,
  FastSendTemplateModificationNotAllowed = 128,
  PayamakSefidUserEventCanNotBeRemoved = 129,
  DuplicateReservedLine = 130,
  UserLinePrebuyRequestNotFound = 131,
  LineAlreadyInUseByUser = 132,
  MissingUserLinePrebuyRequiredAttachments = 133,
  ProviderMissingLineType = 134,
  UserHasIncompleteLinePrebuy = 135,
  UnassignedLinePrebuyRequestExists = 136,
  CannotChangeStatusOfExpiredPrebuy = 137,
  InquiryServiceUnavailable = 138,
  InquiryDailyLimitReached = 139,
  NationalIdAndBirthDateMismatch = 140,
  InvalidCompanyNationalId = 141,
  InvalidUserRegistrationSectionStatusToUpdate = 142,
  MobileAndNationalIdMismatch = 145,
  UserRegistrationSectionAlreadyInquiredWithSameData = 146,
  UserRegistrationSectionInquiryBlocked = 147,
  UserAccessLimitationCountExceeded = 148,
  InquiryServiceAlreadyUsed = 149,
  DuplicateAccessMap = 150,
  DuplicateUserAccess = 151,
  CannotOverrideUserAccess = 152,
  InvoicesAlreadyHaveNumber = 153,
  ProviderDoesNotPermitSuchSending = 154,
  LinkFoundInBlacklist = 155,
  LinkIsInvalid = 156,
  LinkAlreadyExistsInUserWhitelist = 157,
  LinkBlacklistEntryNotFound = 158,
  InvalidFindBlacklistRequest = 159,
  ItemAlreadyExists = 160,
  GuestCanNotBeVerified = 161,
  LinkWhitelistEntryNotFound = 162,
  InvalidGapBetweenSmartZoneCreationAndSend = 163,
  SmartZoneSendNotFound = 164,
  InvalidSmartZoneSendState = 165,
  SmartZoneSendDisabled = 166,
  PostalCodeNotFound = 167,
  UserRegistrationSectionDisplayModeIsManual = 168,
  SmartZoneSendDateAndOrTimesAreInvalid  = 175,
  MessengerSendSendingAlreadyInProgress = 202,
  PaymentCardRequired = 224,
  PaymentCardNotValid = 225,
  UserBankCardDuplicate = 226,
  UserBankCardInvalidNumber = 227,
  UserBankCardNotFound = 228,
  UserBankCardCannotBeDefault = 229,
  UserBankCardLimitReached = 230,
  UserAccessLimitationWorkspaceMembers = 231,
  UserAccessLimitationJoinedWorkspaces = 232,
  MemberOwnMobile = 233,
  MemberDuplicateMobile = 234,
  ForbiddenNotOwner = 235,
  InviteeUserNotEligible = 236,
  MembershipRoleNotAllowed = 237,
  MemberNotFound = 238,
  MemberInvalidStatus = 239,
  WorkspaceAccessDenied = 240,
}
